// src/mocks/browser.js
import { setupWorker } from 'msw'
import { handlers } from './handlers'

let worker = null

function isBrowserEnvironment() {
  return (
    typeof window !== 'undefined' &&
    typeof window.document !== 'undefined' &&
    typeof window.navigator !== 'undefined' &&
    window.location &&
    window.location.protocol &&
    (window.location.protocol === 'http:' ||
      window.location.protocol === 'https:')
  )
}

function isProcessEnvAvailable() {
  return (
    (typeof process !== 'undefined' && process.env) ||
    (typeof window !== 'undefined' && window.process && window.process.env)
  )
}

function getNodeEnv() {
  if (typeof process !== 'undefined' && process.env) {
    return process.env.NODE_ENV
  }
  if (typeof window !== 'undefined' && window.process && window.process.env) {
    return window.process.env.NODE_ENV
  }
  return 'production' // Default to production if not found
}

async function initializeMockServiceWorker() {
  // Ensure we're in a browser environment
  if (!isBrowserEnvironment()) {
    console.log('MSW: Not in a browser environment')
    return null
  }

  // Ensure process.env is available
  if (!isProcessEnvAvailable()) {
    console.log('MSW: process.env not available')
    return null
  }

  // Only initialize in development
  if (getNodeEnv() !== 'development') {
    console.log('MSW: Not in development environment')
    return null
  }

  console.log('MSW: Initializing worker in development environment')

  try {
    // Initialize the worker
    worker = setupWorker(...handlers)

    // Start the worker
    await worker.start({
      onUnhandledRequest: 'bypass',
      serviceWorker: {
        url: '/mockServiceWorker.js',
      },
    })

    console.log('MSW: Worker started successfully')
    return worker
  } catch (error) {
    console.error('MSW: Failed to start worker:', error)
    return null
  }
}

// Export a function to get the worker instead of initializing immediately
export async function getWorker() {
  if (!worker && isBrowserEnvironment()) {
    return initializeMockServiceWorker()
  }
  return worker
}

// Export the worker for backward compatibility
export { worker }
